import App, {Tool} from '../App';
import Api from './Api';
import Resource from '../Resource';

class Section {
    static consumptionList () {
        App.log('SECTION.CONSUMPTION_LIST', App.LOG.FETCH);

        const body = {
            patientFileCode: null,
            patientName: null,
            productNumber: null,
            startIndex: 0,
            pageSize: 1000
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.CONSUMPTION_LIST, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    // static data(props) {
    //     App.log('SECTION_EMER_REQUEST.DATA', App.LOG.FETCH, props);
    //
    //     const body = {
    //         sectionEmgRequestId: props.sectionEmgRequestId
    //     };
    //
    //     return new Promise((resolve, reject) => {
    //         fetch(Api.SECTION_EMER_REQUEST.DATA, {
    //             body: JSON.stringify(body),
    //             method: Tool.METHODS.POST,
    //             headers: Tool.headers()
    //         }).then(response => {
    //             Tool.response(response, {
    //                 '200:0': result => {
    //                     resolve(result.objList[0]);
    //                 },
    //                 'default': result => {
    //                     reject(result.resultMessage);
    //                 }
    //             });
    //         }).catch(_ => {
    //             reject(Resource.STRING.FETCH.GET_FAILED);
    //         });
    //     });
    // }

    // static patientInfo(props) {
    //     App.log('SECTION_EMER_REQUEST.PATIENT_INFO', 'Referring to other method');
    //
    //     return SectionNormRequest.patientInfo(props);
    // }

    // static insert (props) {
    //     App.log('HEMO_ORG_EMER_REQUEST.INSERT', App.LOG.FETCH, props);
    //
    //     const body = {
    //         patientFileCodeId: props?.patientFileCodeId,
    //         patientFileCode: props?.patientFileCode,
    //         patientFirstName: props?.patientFirstName,
    //         patientLastName: props?.patientLastName,
    //         sectionId: props?.sectionId,
    //         docterName: props?.docterName,
    //         patientBiography: props?.patientBiography
    //     };
    //
    //     return new Promise((resolve, reject) => {
    //         fetch(Api.HEMO_ORG_EMER_REQUEST.INSERT, {
    //             body: JSON.stringify(body),
    //             method: Tool.METHODS.POST,
    //             headers: Tool.headers()
    //         }).then(response => {
    //             Tool.response(response, {
    //                 '200:0': result => {
    //                     resolve();
    //                 },
    //                 'default': result => {
    //                     reject(result.resultMessage);
    //                 }
    //             });
    //         }).catch(_ => {
    //             reject(Resource.STRING.FETCH.INSERT_FAILED);
    //         });
    //     });
    // }

    // static update (props) {
    //     App.log('HEMO_ORG_EMER_REQUEST.UPDATE', App.LOG.FETCH, props);
    //
    //     const body = {
    //         hospitalEmgRequestId: props.hospitalEmgRequestId,
    //         wbJson: {
    //             o_POSCount: props.o_POSCount,
    //             o_NEGCount: props.o_NEGCount,
    //             a_POSCount: props.a_POSCount,
    //             a_NEGCount: props.a_NEGCount,
    //             b_POSCount: props.b_POSCount,
    //             b_NEGCount: props.b_NEGCount,
    //             aB_POSCount: props.aB_POSCount,
    //             aB_NEGCount: props.aB_NEGCount,
    //             sum: props.sum,
    //             description: props.description
    //         },
    //         rbcJson: {
    //             o_POSCount: props.o_POSCount,
    //             o_NEGCount: props.o_NEGCount,
    //             a_POSCount: props.a_POSCount,
    //             a_NEGCount: props.a_NEGCount,
    //             b_POSCount: props.b_POSCount,
    //             b_NEGCount: props.b_NEGCount,
    //             aB_POSCount: props.aB_POSCount,
    //             aB_NEGCount: props.aB_NEGCount,
    //             sum: props.sum,
    //             description: props.description
    //         },
    //         pltJson: {
    //             o_POSCount: props.o_POSCount,
    //             o_NEGCount: props.o_NEGCount,
    //             a_POSCount: props.a_POSCount,
    //             a_NEGCount: props.a_NEGCount,
    //             b_POSCount: props.b_POSCount,
    //             b_NEGCount: props.b_NEGCount,
    //             aB_POSCount: props.aB_POSCount,
    //             aB_NEGCount: props.aB_NEGCount,
    //             sum: props.sum,
    //             description: props.description
    //         },
    //         ffpJson: {
    //             o_POSCount: props.o_POSCount,
    //             o_NEGCount: props.o_NEGCount,
    //             a_POSCount: props.a_POSCount,
    //             a_NEGCount: props.a_NEGCount,
    //             b_POSCount: props.b_POSCount,
    //             b_NEGCount: props.b_NEGCount,
    //             aB_POSCount: props.aB_POSCount,
    //             aB_NEGCount: props.aB_NEGCount,
    //             sum: props.sum,
    //             description: props.description
    //         },
    //         cryJson: {
    //             o_POSCount: props.o_POSCount,
    //             o_NEGCount: props.o_NEGCount,
    //             a_POSCount: props.a_POSCount,
    //             a_NEGCount: props.a_NEGCount,
    //             b_POSCount: props.b_POSCount,
    //             b_NEGCount: props.b_NEGCount,
    //             aB_POSCount: props.aB_POSCount,
    //             aB_NEGCount: props.aB_NEGCount,
    //             sum: props.sum,
    //             description: props.description
    //         }
    //     };
    //
    //     return new Promise((resolve, reject) => {
    //         fetch(Api.HEMO_ORG_EMER_REQUEST.UPDATE, {
    //             body: JSON.stringify(body),
    //             method: Tool.METHODS.POST,
    //             headers: Tool.headers()
    //         }).then(response => {
    //             Tool.response(response, {
    //                 '200:0': result => {
    //                     resolve();
    //                 },
    //                 'default': result => {
    //                     reject(result.resultMessage);
    //                 }
    //             });
    //         }).catch(_ => {
    //             reject(Resource.STRING.FETCH.UPDATE_FAILED);
    //         });
    //     });
    // }

    // static delete(props) {
    //     App.log('SECTION_EMER_REQUEST.DELETE', 'Referring to other method');
    //
    //     return SectionNormRequest.delete(props);
    // }
}

export default Section;